import { IComponent } from '../lib/type';

export interface IMessage {
  _id?: string; //Unique ID
  type: number | string; //Message type
  user?: {
    avatarType: 'key' | 'url' | 'component';
    avatar?: string | IComponent; //Profile photo
  };
  component?: IComponent;
  content: any;
  expansion?: IComponent[]; //Message extension component
  createTime?: number | string;
  hasTime?: boolean;
  position?: 'left' | 'center' | 'right' | 'fixed'; //Message location
  flightStatus?: number; //Send status
}

export const MESSAGE_TYPE = {
  CMD: 'cmd',
};

export const CMD_CODE = {
  RENDER: 'render',
  EXEC: 'exec',
};

export const SEND_ORIGIN = {
  INPUT: 'input',
  QUICK_BUTTON: 'quickButton',
};

// cmd Message
